<div class="flex-align-center horizontal-bar-L pad-0-S gap-XS greyed-hover border-grey c-p" matRipple
     [class.none-events]="disabled" [class.greyed-out]="disabled">
    <ng-content></ng-content>
</div>
